import { MessageCircle } from "lucide-react";
import { useLang } from "@/i18n";

const NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER;

/** Bare click-to-chat link (no prefilled message) for footer/contact lists. */
export const waLink = NUMBER ? `https://wa.me/${NUMBER}` : null;

/** WhatsApp click-to-chat. variant: "inline" | "floating". */
const WhatsAppButton = ({ variant = "inline" }) => {
  const { t } = useLang();
  if (!NUMBER) return null;
  const link = `https://wa.me/${NUMBER}?text=${encodeURIComponent(t("wa.message"))}`;

  if (variant === "floating") {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float"
        aria-label={t("wa.aria")}
        className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-[#25D366] text-white font-bold pl-4 pr-5 py-3.5 rounded-full shadow-lg hover:scale-105 transition-transform duration-200"
      >
        <MessageCircle size={20} /> <span className="hidden sm:inline">WhatsApp</span>
      </a>
    );
  }

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-inline"
      className="group inline-flex items-center gap-2 bg-[#25D366] text-white font-bold px-6 py-3.5 rounded-full hover:bg-[#1da851] transition-colors duration-200"
    >
      <MessageCircle size={18} /> {t("wa.chat")}
    </a>
  );
};

export default WhatsAppButton;
